const getters = {
  getIsLoading(state) {
    return state.isLoading;
  },
  getLayout(state) {
    return state;
  },
  getQueries: (state) => state.query,

  getKeepAlive: (state) => state.keepAlive,

  getKey: (state) => state.key
};

export default getters;
